import React, { useCallback, useEffect, useState } from 'react'
import Header from 'components/Header'
import { Col, Row } from 'react-bootstrap'
import { reqGetActiveOrders } from '../order_components/OrderRequests'
import OrdersList from 'order_components/OrdersList'
import { IOrder } from 'order_components/IOrder'
import MySpinner from 'components/MySpinner'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { removeSearchParam } from 'utils/UrlUtils'
import { PAGE_URL_HISTORY, SP_NEW_ORDER } from 'SiteURLs'
import AfterOrderRequestDialog from './AfterOrderRequestDialog'

const ActiveOrdersPage: React.FC = () => {
  const navigate = useNavigate()
  const [orders, setOrders] = useState<IOrder[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [showInfoDialog, setShowInfoDialog] = useState(false)
  const [sp, setSp] = useSearchParams()

  useEffect(() => {
    let mount = true
    reqGetActiveOrders((newBids) => {
      if (mount) {
        setOrders(newBids)
        setIsLoading(false)
      }
    })
    return () => {
      mount = false
    }
  }, [])

  useEffect(() => {
    const new_order = sp.get(SP_NEW_ORDER)
    if (new_order) {
      setShowInfoDialog(true)
      removeSearchParam(SP_NEW_ORDER, sp, setSp)
    }
  }, [sp, setSp])

  const handleCancel = useCallback(
    (bidItem: IOrder) => {
      setOrders(
        orders.filter((item) => {
          return item.order_id !== bidItem.order_id
        })
      )
      navigate('/' + PAGE_URL_HISTORY)
    },
    [orders, navigate]
  )

  return (
    <>
      <Row>
        <Col xs={12} className='pt-header'>
          <Header>Активные заказы</Header>
          {isLoading ? (
            <MySpinner />
          ) : orders.length === 0 ? (
            <div className='h3-rem'>У Вас пока нет активных заказов</div>
          ) : (
            <>
              <div className='big-product-name-font mb-2'>
                Заказы будут отменены через <strong>семь дней</strong> после оформления,
                если их не забрать
              </div>
              <OrdersList orders={orders} onCancel={handleCancel} />
            </>
          )}
        </Col>
      </Row>

      <AfterOrderRequestDialog
        open={showInfoDialog}
        onClose={() => setShowInfoDialog(false)}
      />
    </>
  )
}
export default ActiveOrdersPage
